import React from 'react';
import Icon from '../../../components/AppIcon';

const EmptyState = ({ searchQuery }) => {
  return (
    <div className="rounded-lg bg-card p-12 text-center shadow-card">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
        <Icon name="Users" size={32} className="text-muted-foreground" />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-foreground">
        {searchQuery ? '검색 결과가 없습니다' : '등록된 고객이 없습니다'}
      </h3>
      <p className="text-sm text-muted-foreground">
        {searchQuery 
          ? '다른 검색어로 다시 시도해보세요' :'첫 주문이 접수되면 고객 정보가 자동으로 등록됩니다'}
      </p>
    </div>
  );
};

export default EmptyState;